import { useMemo } from "react";
import axios from "axios";

import api, { useSWR } from "../utils/axios";
import { HOST_API } from "../config-global";

const baseUrl = `/api/identity-provider/`;

export function useGetIdentityProvider() {
  const { data, isLoading, error, isValidating, mutate } = useSWR(baseUrl);

  const memoizedValue = useMemo(
    () => ({
      identityProvider: data || null,
      isLoading,
      error,
      isValidating,
      mutate,
    }),
    [data, error, isLoading, isValidating, mutate]
  );

  return memoizedValue;
}

export function update(request) {
  return api.put(baseUrl, { ...request });
}

export function discover(discoveryUrl) {
  return api.post(`${baseUrl}discover`, { discoveryUrl });
}

// Anonymous calls: they bypass the interceptors so each page reports its own errors
export function getStart(enterpriseCode) {
  return axios.get(`${HOST_API}${baseUrl}start/${encodeURIComponent(enterpriseCode)}`);
}

export function loginIdentityProvider(data) {
  return axios.post(`${HOST_API}/api/users/login-idp`, data);
}
